export class ApplicationsRoutingConstants {
    static APPLICATIONS_ROUTE = "applications";
    static REFRESH_ROUTE = "refresh";
    static REFRESH_VIEW_APPLICATION_ROUTE = "refreshViewApplication";
    static REFRESH_CREATE_APPLICATION_ROUTE = "createApplicationRefreshRoute";
}
